import { motion } from "framer-motion";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const achievements = [
  { value: "130+", label: "Countries reached by RIT's Tiger STRIPES within one year" },
  { value: "2X", label: "Better yield rate secured for Saint Louis University" },
  { value: "100%", label: "Excelerate user base growth across 190+ countries in two years" },
];

export const Founder = () => {
  return (
    <section id="founder" className="bg-[#FAF7F2] text-[#1A2238] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="max-w-3xl mb-16">
          <motion.p variants={fadeUp} className="eyebrow text-[#FF6A3D] mb-6">
            Our Founder
          </motion.p>
          <motion.h2 variants={fadeUp} className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter leading-[1.05]">
            Shaping Growth for Global Education Brands
          </motion.h2>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-12 items-start">
          {/* Left: monogram + identity */}
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="lg:col-span-4">
            <motion.div
  variants={fadeUp}
  className="relative aspect-[4/5] overflow-hidden rounded-2xl shadow-[0_30px_80px_rgba(26,34,56,0.18)] bg-[#E3E3E3]"
>
  <img
    src="/Founder Logo.jpeg"
    alt="Raj Rakshit"
    className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
  />

  {/* Gradient overlay */}
  <div className="absolute inset-0 bg-gradient-to-t from-[#1A2238]/40 via-transparent to-transparent" />

  {/* Accent line */}
  <div className="absolute bottom-6 left-6 h-1 w-16 bg-[#FF6A3D]" />
</motion.div>
            <motion.div variants={fadeUp} className="mt-6">
              <div className="font-display text-2xl font-bold tracking-tight">Raj Rakshit</div>
              <div className="text-sm font-semibold text-[#1A2238]/55 mt-1">Founder, DOMINATE</div>
            </motion.div>
          </motion.div>

          {/* Right: copy + stats */}
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="lg:col-span-8">
            <motion.div variants={fadeUp} className="space-y-5 text-base lg:text-lg text-[#1A2238]/70 leading-relaxed">
              <p>Raj brings 4+ years of experience building digital growth for education and experiential learning brands across global markets.</p>
              <p>
                Alongside DOMINATE, Raj continues to play a key role in shaping and scaling Excelerate, a global
                experiential learning platform that has reached <strong className="text-[#1A2238]">250,000+ learners across 190+ countries</strong>.
              </p>
              <p>
                That gives DOMINATE an edge: our strategies are not built from outside observation. They are shaped
                by active, real-world experience in growing education brands, learner communities, and global learning programs.
              </p>
              <p>
                Through Excelerate, Raj also leads growth for programs associated with leading education brands including{" "}
                <strong className="text-[#1A2238]">Saint Louis University</strong> and{" "}
                <strong className="text-[#1A2238]">Rochester Institute of Technology</strong>.
              </p>
            </motion.div>

            <motion.div variants={fadeUp} className="mt-10 grid sm:grid-cols-3 border-t border-l border-[#1A2238]/12">
              {achievements.map((a) => (
                <div key={a.value} className="border-b border-r border-[#1A2238]/12 p-6">
                  <div className="font-display text-4xl font-extrabold tracking-tighter text-[#FF6A3D]">{a.value}</div>
                  <div className="mt-2 text-sm text-[#1A2238]/60 leading-snug">{a.label}</div>
                </div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
